<template>
  <div>
    <div v-if="debug_show_page_name==true" style="color:green;">certificate-list-modal</div>
    <modal class="yobiki_select-modal" width="800px"   :value="showModal" effect="fade" @closed="closed"  large>
      <!-- custom header -->
      <div slot="modal-header" class="modal-header">
        <h4 class="modal-title">
          <center><strong>{{title_label}}</strong></center>
        </h4>
      </div>
      <div  class="modal-body yobiki_select-modal-body " style="height: 500px;padding: 0px 15px; overflow-x: auto;" >
        <ag-grid-vue style="min-width:100px;width: 100%; height: 475px" class="ag-blue" :gridOptions="gridOptions" :rowData="rowData"></ag-grid-vue>
      </div>
                <div style="float: left;;margin-top:5px">
            件数
          </div>
          <input type="text" data-cy="totalNumberOfRows" style="width: 5%;text-align: right;float: left;margin-left:5px" class="form-control limited-height-box" :disabled="true" :value="totalNumberOfRows" />
        <div slot="modal-footer" class="modal-footer" style="background:white;margin-top:20px">
        <div style="float:left">
        </div>
        <button 
        :disabled="formExportFileDisabled"
        type="button" class="btn btn-primary " @click="closed('yes')" >出力</button>
        <button type="button" class="btn btn-default " @click="closed('no')">戻る</button>
      </div>
    </modal>
  </div>
</template>

<script>
import Vue from 'vue';
import { bus } from '@/libs/bus';
import { utils } from '@/libs/utils';
var vm = this;

import modal from './local-modal';
import output_config from '../../rules/output_config.js';
import { AgGridVue } from 'ag-grid-vue';
import mixinPageCommon from "@/mixins/mixin_page_common";
import mixinDatasource from "@/mixins/mixin_datasource";

Vue.component('modal', modal);
import _ from 'lodash';
import debug from 'debug';
var debug_yobiki = debug('esma:certificate-list-modal');
export default {
   mixins:[
        mixinPageCommon,mixinDatasource
  ],
  components: {
    'ag-grid-vue': AgGridVue
  },
  data() {
    return {
      show_modal: false,
      selected_data :false,
      row_data:[],
      title_label:"",
      api_name:"inventory_unreport_list",
      // api_name:"certificate",
      search_timeout : false,
      // search_model:"",
      subseach:{},
      device_control_number:false,
      state_last_filter_options:"last_filter_options3",
      selected_row :false
    };
  },
  computed: {
    selectedRow:{
      get(){
        return this.selected_row;
      },
      set(v){
        this.selected_row = v;
      }
    },
    // searchModel:{
    //   get(){
    //     return this.search_model;
    //   },
    //   set(v){
    //     this.search_model = v;
    //   }
    // },
    rowData:{
      get(){
        return this.row_data;
      },
      set(v){
        this.row_data = v;
      }
    },
    selectedData:{
      get(){
        return this.selected_data;
      },
      set(v){
        this.selected_data = v;
      }
    },

    pageID() {
      return this.$props.pageid;
    },
    showModal() {
      return this.show_modal;
    }
  },
  methods: {
    onSearch(){  
      clearTimeout(this.search_timeout);
      this.search_timeout = setTimeout(()=>{
        this.searchControlChangedDatasource(
          {
            "1":{block: "1", field: "reporting_period", value: this.subseach.reporting_period, ct: "v", ca: false, t: "input"},
            "2":{block: "2", field: "company", value: this.subseach.company, ct: "v", ca: false, t: "input"},
            "3":{block: "3", field: "jurisdiction_classification", value: this.subseach.jurisdiction_classification, ct: "v", ca: false, t: "input"},
            // "2":false,
            // "3":false,
            "j1": "AND",
            "j2": "AND",
            "b2_disabled": false,
            "b3_disabled": true
          }
        )
      },(false)?0:300)
    },
    showModalWindow(data) {
      this.title_label = data.title;
      this.subseach = data.send_subsearch;
      this.show_modal = true;
      this.onSearch("");
    },
    closed(mode) {
      this.show_modal = false;
      this.$emit('done', mode);
    },
    createColumnDefs(){
      return [
            {
          headerName: '状態',
          field: 'approval_status',
          hide: false,
          sort: 'desc',
          // table_field_style:{
          //   "報告済":"color:;",
          //   "申請中":"color:blue;",
          //   "下書中":"color:#a0283a",
          //   "差戻":"color:green;",
          //   "未報告":"color:red;"
          // },
          width:50
            },
                {
          headerName: 'システム',
          field: 'reporting_system',
          hide: false,
          width:360
        },
        {
          headerName: '部署', 
          field: 'department_in_charge',
          hide: false,
          width:325
        },
        // {
        //   headerName: 'チーム', 
        //   field: 'team_in_charge',
        //   hide: false,
        //   width:275
        // },
        {
            headerName: "SearchFlowControl",// Used to filter manually
            field: "search_flow_control",
            hide: false
        },
    ];
    }
  },
  props: {
    tag: { type: String, default: 'showCertificateListModal' },
    pageid: { type: String }
  },
   beforeMount() {
    // this.$store.state.current_row = {};

    //AG Grid options
    this.gridOptions = {
      defaultColDef: {
        editable: false
      },
      getRowNodeId: function(data) {
        return data.seq_id;
      },
      enableSorting: true,
      suppressMovableColumns: true,
      rowSelection: 'single',
      enableColResize: false,
      suppressHorizontalScroll: true,
      overlayNoRowsTemplate :"<span class=\"ag-overlay-loading-center\">対象のデータはありません</span>",
      onRowSelected: ev => {
      },
    };
    // this.api_request_options = {sub_search:"subseach"};
    this.initDatasource({});
  },
  mounted() {
    bus.$on(this.$props.tag, this.showModalWindow);
  },
  beforeDestroy() {
    bus.$off(this.$props.tag);
  }
};

</script>
<style scoped>

.info_div {
  width: 32%;
  float: left;
}
.mh_td2 {
  margin: 2px 0px;
  border: 0px solid #bdbdbd;

  font-size: 11px;
  font-weight: 500;
  padding: 4px 0px 4px 4px;
}

.mh_td_h2 {
  margin: 2px 0px;
  _border: 1px solid #bdbdbd;
  _background-color: #b4d5f1;
  padding: 4px 8px;
  font-size: 11px;
  _font-weight: 900;
}
.fa-spin-custom, .glyphicon-spin {
    -webkit-animation: spin 1500ms infinite linear;
    animation: spin 1500ms infinite linear;
}

@-webkit-keyframes spin {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg);
    }
}
@keyframes spin {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg);
    }
}
</style>



// WEBPACK FOOTER //
// inventory-unreport-list-it.vue?1567496a